import React from 'react';
export function AboutUsPage() {
  return <main className="pb-6" data-id="element-2386">
      <div className="max-w-4xl mx-auto px-4" data-id="element-2387">
        {/* Header */}
        <header className="mb-10 sm:mb-12" data-id="element-2388">
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" data-id="element-2389">
            About Us
          </h1>
        </header>

        {/* Content */}
        <article className="prose prose-lg dark:prose-invert max-w-none" data-id="element-2390">
          <div className="space-y-6 text-lg leading-relaxed" data-id="element-2391">
            <p data-id="element-2392">
              Maestro Connect is a modern platform built to simplify and elevate
              private music education.
            </p>

            <p data-id="element-2393">
              We help music teachers manage students, lessons, scheduling,
              tasks, and communication in one clear, professional system — while
              giving students a focused, structured learning experience.
            </p>

            <p data-id="element-2394">
              Maestro Connect also enables students and teachers to connect
              through a shared learning platform designed around real lesson
              workflows.
            </p>

            <p data-id="element-2395">
              The platform is designed by musicians, for musicians. We
              understand the real challenges teachers face: scattered tools,
              missed lessons, unclear progress tracking, and time lost on
              administration instead of teaching. Maestro Connect brings
              everything together so teachers can focus on what matters most —
              teaching — and students can stay motivated, organized, and
              progressing.
            </p>

            <p data-id="element-2396">
              Our mission is to modernize music education without
              overcomplicating it. Maestro Connect is intentionally clean,
              practical, and built to grow with teachers, studios, and schools
              worldwide.
            </p>

            <p className="font-medium" data-id="element-2397">
              We're building long-term infrastructure for music education — not
              just another app.
            </p>
          </div>
        </article>
      </div>
    </main>;
}